import { GetValueCallback, IMatcher } from './IMatcher';

export class MatchAnd implements IMatcher {
  readonly matchers: IMatcher[];

  constructor(matchers: IMatcher[]) {
    this.matchers = matchers;
  }

  match(getValue: GetValueCallback): boolean {
    return this.matchers.every((matcher) => matcher.match(getValue));
  }
}
